export enum AdminFinancialsChartDataTypeCode{
    TicketsSold = 0,
    Revenue = 1,
    SalesTaxes = 2
}